import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Construction } from "lucide-react";

export default function ScaffoldPage({ title, description }) {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight" style={{ fontFamily: "Chivo, sans-serif" }}>{title}</h1>
      <Card className="border border-gray-200 rounded-sm">
        <CardContent className="p-12 text-center">
          <Construction size={48} className="mx-auto text-gray-300 mb-4" />
          <h2 className="text-lg font-bold text-gray-700 mb-2">{title}</h2>
          <p className="text-sm text-gray-500 mb-4">{description || "This module is scaffolded for future development."}</p>
          <Badge variant="outline" className="rounded-sm">SCAFFOLD - Coming Soon</Badge>
        </CardContent>
      </Card>
    </div>
  );
}
